export const ROLE_ADMIN = 'BESLISSINGSBEVOEGD';
export const ROLE_USER = 'GEBRUIKER';
export const ROLE_CONTACT_PERSON = 'CONTACTPERSOON';

export const BUSINESS_EMAIL_ADDRESS = 'tikkie.business.support@nl.abnamro.com';
